module.exports = __webpack_public_path__ + "static/media/analysis.f85e410d.svg";